import type { PlaylistItem } from '@/shared/models/playlist.model';

function normalizar(s: string): string {
  return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

/**
 * Filtra itens da playlist pelo termo de busca.
 * Tolerante a acentos e palavras fora de ordem:
 * todos os tokens do termo devem aparecer em (titulo + canal).
 */
export function filtrarPlaylist(itens: PlaylistItem[], termo: string): PlaylistItem[] {
  if (!termo.trim()) return itens;
  const tokens = normalizar(termo).split(/\s+/).filter(Boolean);
  return itens.filter(item => {
    const haystack = normalizar(`${item.titulo} ${item.canal ?? ''}`);
    return tokens.every(token => haystack.includes(token));
  });
}
